import { makeAutoObservable } from "mobx";

import { AppRole, UserPermissionsDto } from "../../@api";

export class PermissionStore {
  private _userPermissions: UserPermissionsDto = { isPermissionAdmin: false, roles: [] };

  private _isLoadingPermissions: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  public get isLoadingPermissions() {
    return this._isLoadingPermissions;
  }

  public set isLoadingPermissions(isLoading: boolean) {
    this._isLoadingPermissions = isLoading;
  }
  public get userPermissions() {
    return this._userPermissions;
  }

  public setUserPermissions(userPermissions?: UserPermissionsDto) {
    this._userPermissions = userPermissions ?? {
      isPermissionAdmin: false,
      roles: [],
    };
  }

  public hasRole(role: AppRole) {
    return this._userPermissions.roles.includes(role);
  }

  public hasAnyRole(roles: AppRole[]) {
    return roles.some(role => this._userPermissions.roles.includes(role));
  }

  public isPermissionAdmin() {
    return this._userPermissions.isPermissionAdmin;
  }

  public hasAnyPermission() {
    return this._userPermissions.roles.length > 0 || this._userPermissions.isPermissionAdmin;
  }
}
